import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function useEventListener(eventName, handler, element, options) {
    const savedHandler = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(handler);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const targetElement = (null == element ? void 0 : element.current) || window;
        const isSupported = !!(null == targetElement ? void 0 : targetElement.addEventListener);
        if (!isSupported) return;
        const eventListener = (event)=>savedHandler.current(event);
        targetElement.addEventListener(eventName, eventListener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
const useEventListener_rslib_entry_ = useEventListener;
export { useEventListener_rslib_entry_ as default };
